import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleDescription} from '../common/infoBubbles/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {InfoBubblePill, InfoBubblePillVariantsEnum} from '../common/infoBubbles/infoBubblePill';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const PrivateCommentInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();
  const onClose = () => context.closeInfoBubbles(OnboardingTipTypesEnum.PRIVATE_INBOX_COMMENT);

  return (
    <InfoBubble
      {...context}
      position="bottom-start"
      type={OnboardingTipTypesEnum.PRIVATE_INBOX_COMMENT}
      targetRef={targetRef}
      isInteractive
      interactionId="private-inbox-comment"
    >
      <InfoBubbleContent>
        <InfoBubblePill type={InfoBubblePillVariantsEnum.EDUCATION} />
        <InfoBubbleTitle>
          <Trans id="infobubble-private-comment-title">Only you can see this</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-private-comment-description">
            If you want to share your thoughts, @mention teammates in your comment.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button onClick={onClose} size={VisualSizesEnum.MEDIUM} variant={ButtonVariantsEnum.PRIMARY}>
            <Trans id="infobubble-private-comment-cta">Got it!</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
